import { useNuxtApp } from 'nuxt/app';
import { useLocaleCodeToUrl } from '~~/common/composables/useLanguage';

let availableLocalesPrivate;

function useLocale () {
  return useNuxtApp().$i18n.locale;
}
function useLocales () {
  return useNuxtApp().$i18n.locales;
}

export default {
  computed: {
    locale () {
      return useLocale().value;
    },
    availableLocales () {
      if (!availableLocalesPrivate) {
        availableLocalesPrivate = useLocales().value.map(l => ({
          text: l.code.toUpperCase(),
          lowerCaseText: l.code.toLowerCase(),
          upperCaseText: l.code.toUpperCase(),
        }));
      }
      return availableLocalesPrivate;
    },
    localeCodeToUrl () {
      return useLocaleCodeToUrl().value;
    },
  },
};
